export default __webpack_public_path__ + "static/media/accuracy.20de5b3e.PNG";